import React, {Component} from 'react'
import './styles.css'
import {Formik, Field, Form} from 'formik'
import {apiEmployee} from '../../services/apiamrg'
import Header from '../../components/header'
import {connect} from 'react-redux'
import {Redirect, Link} from 'react-router-dom'
import {NOME_EMPRESA, PRECISA_LOGAR} from '../../config'
import moment from 'moment'
import Util from '../../classes/util'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faTimesCircle} from '@fortawesome/free-regular-svg-icons'

import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Formlabel from '@material-ui/core/FormLabel'
import Lottie from 'react-lottie';
import *  as loader123 from './loading.json'
import {confirmAlert} from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'
import { Button } from '@material-ui/core'

const estadoInicial = {
    name: '',
    weather: [],
    loading: true,
    redirect: false,
    id_weather: '',
    imagem: '',
    thumb: [],
    imagem2: '',
    thumb2: [],
    parametros: [],
    titulo:'',
    mensagem: '',
    mostrarloading: false

}
const defaultOptions = {
    loop: true,
    autoplay: true, 
    animationData: loader123,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

class Configuracao extends Component {
    state = {
        ...estadoInicial
    }
    componentDidMount = async () => {
        window.scrollTo(0, 0)
         this.getWeather()
    }

    

    getWeather = async () => {
        await apiEmployee.post(`getWeather.php`, {
            token: this.props.token
        }).then(
            async response => {
                if(response.data == 'false'){
                    alert('erro ao carregar os dados')
                }else{
                    await this.setState({weather: response.data})
                    await this.getParametros()
                }
            },
            )
        }

        getParametros = async () => {
            await apiEmployee.post(`getParametros.php`, {
                token: this.props.token
            }).then(
                async response => {
                    if(response.data == 'false'){
                        alert('erro ao carregar os dados')
                    }else{
                        await this.setState({parametros: response.data})
                       await this.setState({id_weather: response.data[0].id_weather, name: response.data[0].nome})
                       document.getElementById('Weather').value = response.data[0].id_weather
                    }
                },
                )
            }



            sendNotification = async () => {
                if( this.state.mensagem != '' && this.state.titulo != ''){
                    this.setState({mostrarloading:true})
                await apiEmployee.post(`sendNotification.php`, {
                    mensagem: this.state.mensagem,
                    titulo: this.state.titulo
                }).then(
                    async response => {
                        if(response.data == 'false'){
                            alert('erro ao carregar os dados')
                            this.setState({mostrarloading:false})
                        }else{
                          alert('Mensagem: '+ this.state.mensagem + ' Com Titulo : '+this.state.titulo + ' foi enviado!')
                          this.setState({mostrarloading:false})
                        }
                    },
                    )
                }
            }


        fileSelectedHandler = async (event) => {
            console.log(event.target.files[0])
            if(event.target.files[0] != null){
            await this.setState(
                {
                    thumb: [URL.createObjectURL(event.target.files[0])], 
                    imagem: event.target.files[0]
                }
            )
            }
            console.log('LineUpBR: ' + this.state.imagem)
        }
        fileSelectedHandler2 = async (event) => {
            console.log(event.target.files[0])
            if(event.target.files[0] != null){
            await this.setState(
                {
                    thumb2: [URL.createObjectURL(event.target.files[0])], 
                    imagem2: event.target.files[0]
                }
            )
            }
            console.log('Brazil Statistics: ' + this.state.imagem)
        }

        toBase64 = file => new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result)
            reader.onerror = error => reject(error)
        });

    
        salverconfig = async () => {
            if(this.state.weather[0] != undefined && this.state.id_weather != '' && this.state.id_weather != -1){
                await apiEmployee.post(`updateWeather.php`, {
                    name: this.state.name,
                    id_weather: this.state.id_weather
                }).then(
                    async res => {
                        if(JSON.stringify(res.data) == 'true'){
                            alert('Weather Alterado !')
                        }else{
                            alert(`Erro ao alterar Weather`)
                        }    
                    }
                )
            }


            if(this.state.imagem != ''){
                let result = await this.toBase64(this.state.imagem)
                console.log(result)
                await apiEmployee.post('insertpdf.php', {
                    token: this.props.token,
                    picture: result
                }).then(
                    async res => {
                        if(JSON.stringify(res.data) != 'false'){
                            alert('Salvo Line Up Brazil!')
                            console.log(res.data)
                        }else{
                            alert('Erro, tente novamente!')
                        }
                    },
                )
            }
            if(this.state.imagem2 != ''){
                let result = await this.toBase64(this.state.imagem2)
                console.log(result)
                await apiEmployee.post('inserpdf2.php', {
                    token: this.props.token,
                    picture: result
                }).then(
                    async res => {
                        if(JSON.stringify(res.data) != 'false'){
                            alert('Salvo  Brazil Statistics!')
                            console.log(res.data)
                        }else{
                            alert('Erro, tente novamente!')
                        }
                    },
                )
            }
            
        } 

        

    render(){
        const validations = []
        validations.push(this.state.mensagem && this.state.mensagem.trim().length >= 3)
        validations.push(this.state.titulo[0])
        //o formulário só será válido se todas as validações forem verdadeiras, com este reduce implementado
        const validForm = validations.reduce((t, a) => t && a)
        return(
            <div>
                  <Header voltarShips/>
                  <div className="row">
                        <div className="col-lg-12">
                            <div className="page-breadcrumb">
                                <h2 style={{marginBottom: '3%', marginTop: '3%', textAlign: 'center'}}>Configurações Gerais</h2>
                            </div>
                        </div>
                        </div>
                        <div className="contact-section">
                    
                    <div className="row">
                        <div className="col-lg-12">
                            <Formik 
                            initialValues={{
                                name: '',
                                weather: [],
                                loading: true,
                                redirect: false,
                                id_weather: this.state.parametros.id_weather,
                                imagem: '',
                                thumb: [],
                                parametros: [],
                            }}
                            onSubmit={async values => {
                                this.salverconfig()
                            }}>
                                <Form className="contact-form">

                                <div className="row">
                                    <div className="col-2"></div>
                                    
                                    <div className="col-8 row ">
                                        
                                        <div className="row"> 
                                            <div className="col-2">
                                                <label htmlFor="Weather">Weather</label>
                                            </div>
                                            <div className="col-10">
                                                <select 
                                                    className="form-control" 
                                                    as="Weather" 
                                                    name="Weather" 
                                                    id="Weather" 
                                                    onChange={async e =>  {
                                                        var doc =  document.getElementById('Weather') 
                                                        var value = doc.options[doc.selectedIndex].value
                                                        var text = doc.options[doc.selectedIndex].text
                                                        this.setState({id_weather: value, name:text})  
                                                    }
                                                    
                                                    
                                                    }>
                                                    <option value={-1}>Escolha um status...</option>
                                                    {this.state.weather.map(seaport => (
                                                    <option value={seaport.id} key={seaport.id}>{seaport.nome}</option>
                                                ))}
                                                </select>
                                                
                                            </div>
                                            

                                        </div>
                                        <div className="col-2">
                                                    <label htmlFor="file">LineUp Brazilian</label>
                                                </div>
                                                <div className="col-10">
                                                    <input type="file" name="file" className="form-control-lg" accept=".pdf" onChange={this.fileSelectedHandler}/>
                                                    <span className='spanerror'>{this.state.spanerror3}</span>  
                                                
                                                    </div>
                                                <div className='col-12 row' style={{borderWidth:1, borderColor:'black', borderStyle:'solid'}}>
                                                <div className="col-12">
                                                    <div style={{display:'flex', justifyContent:'center', alignItems:'center', width:'100%', marginBottom:40, fontSize:18, marginTop: 20}}>Notificação</div>
                                                </div>  
                                                <div className='col-1'></div>
                                                <div className='col-4'>
                                                <div style={{display:'flex', justifyContent:'center', alignItems:'center', width:'100%'}}>Titulo</div>                                                    
                                                    </div>   
                                                    <div className='col-2'></div>    
                                                    <div className='col-4'>
                                                <div style={{display:'flex', justifyContent:'center', alignItems:'center', width:'100%'}}>Mensagem</div>                                                    
                                                    </div>      
                                                    <div className='col-1'></div> 
                                                    <div className='col-1'></div>
                                                    <div className='col-4'>
                                                    <Field value={this.state.titulo} onChange={e => { this.setState({titulo: e.currentTarget.value})}} id="titulo_notifacao" name="titulo_notifacao" type="text" placeholder="Titulo" style={{marginTop:20}} />

                                                    </div>
                                                    <div className='col-2'></div> 
                                                    <div className='col-4'>
                                                    <Field value={this.state.mensagem} onChange={e => { this.setState({mensagem: e.currentTarget.value})}} id="mensagem_notifacao" name="mensagem_notifacao" type="text" placeholder="Mensagem" style={{marginTop:20}} />

                                                    </div> 
                                                    <div className='col-1'></div>
                                                    <div className="col-12">
                                                    <div style={{display:'flex', justifyContent:'center', alignItems:'center', width:'100%', marginTop:40, marginBottom:30, flexDirection: 'column'}}>
                                                    {this.state.mostrarloading && <img src={require('./loading.gif')} alt="loading..."  className='img-fluid imgloadingnotification'/>}

                                                            <div className='btn btn-dark' onClick= {() => this.sendNotification()} type='button' style={!validForm ? {pointerEvents:'none', opacity:0.5}: {}}>Enviar Notificação</div>

                                                    </div>
                                                </div>  
                                                </div>
                                                <div className="col-2">
                                                    <label htmlFor="file">Brazil Statistics</label>
                                                </div>
                                                <div className="col-10">
                                                    <input type="file" name="file" className="form-control-lg" accept=".pdf" onChange={this.fileSelectedHandler2}/>
                                                    <span className='spanerror'>{this.state.spanerror3}</span>  
                                                
                                                    </div>
                                                            
                                    </div>
                                     <div className="col-2"></div>
                                </div>
                                
                                <div className="row">
                                    <div className="col-2"></div>
                                    <div className="col-8" style={{display:'flex',justifyContent:'center'}}>
                                        <button  type="submit" style={ {width:300} } > Salvar </button>
                                    </div>
                                    <div className="col-2"></div>
                                </div>

                                </Form>
                            </Formik>
                        </div>
                    </div>
                
            </div>
                        
            </div>
        )
    }

    }

const mapStateToProps = ({user, servidor}) => {
    return{
        token: user.token,
        online: servidor.online
    }
}

export default connect(mapStateToProps, null)(Configuracao)